<template>
   <div v-if="!showFavs" class="sidebar-fixed position-fixed">
    <template v-if="ai===1 || ai===9">
    <div v-if="authorized" class="d-flex justify-content-start mt-3">
      <div v-if="ai===9">
        <div class="mb-3">
        <btn block color="danger" @click="$bus.$emit('CreateSupplierOrder')">ЗАКАЗАТЬ</btn>
      </div>
           Схема обеcпечения
           <select v-model="selectedScheme" @change="selectScheme($event)" class="form-control custom-select" id="inputGroupSelect01">
            <template v-for="(scheme, index) in deliverySchemes">
              <option :key="index" :value="scheme.Ref_Key">{{scheme.Description}}</option>
            </template>
          </select>
      </div>
    </div>
    <div v-if="ai===9" class="custom-control custom-checkbox">
      <div class="custom-control custom-radio">
        <input @input="changeAll()" type="radio" class="custom-control-input" id="All" name="disabledGroupExample" checked>
          <label class="custom-control-label" for="All">Все</label>
      </div>
      <div class="custom-control custom-radio">
        <input @input="changeNotInStock()" type="radio" class="custom-control-input" id="NotinStock" name="disabledGroupExample" unchecked>
        <label class="custom-control-label" for="NotinStock">Необеспеченные</label>
      </div>
      <div class="custom-control custom-radio">
        <input @input="changeInStock()" type="radio" class="custom-control-input" id="inStock" name="disabledGroupExample" unchecked>
        <label class="custom-control-label" for="inStock">Про запас</label>
      </div>
     </div>
    <list-group v-if = "!showFavs" class="mt-3 animated fadeIn">
      <list-group-item :action="true" @click.native="activeFolder0 = -1, activeFolderUid0 = '00000000001',$emit('folder0','00000000001'),$emit('folder2','00000000001'),$emit('folder1','00000000001')" :active="activeFolder0 === -1">КАТАЛОГ</list-group-item>
    </list-group>
    <list-group v-if = "!showFavs" class="light-blue-color text-uppercase animated fadeIn" v-for="(folder0, index0) in folderList0" :key="index0">
      <list-group-item :action="true" @click.native="cngfolder0(folder0, index0)" :active="activeFolder0 === index0">{{folder0.NomNaim}}</list-group-item>
        <list-group v-if="folder0.NomCode === activeFolderUid0" class="list-group-flush" v-for="(folder1, index1) in folderList1" :key="index1">
          <list-group-item class="btn btn-sm color-white blue-grey-text" :action="true" @click.native="cngfolder1(folder1, index1)" :active="activeFolder1 === index1">{{folder1.NomNaim}}</list-group-item>
            <list-group v-if="folder1.NomCode === activeFolderUid1" class="list-group-flush" v-for="(folder2, index2) in folderList2" :key="index2">
              <list-group-item class="btn btn-sm2 color-white " :action="true" @click.native="activeFolder2 = index2, activeFolderUid2 = folder2.NomCode, $emit('folder2',folder2.NomCode),$emit('folder1',folder2.RoditelCode)" :active="activeFolder2 === index2">{{folder2.NomNaim}}</list-group-item>
            </list-group>
          </list-group>
      </list-group>
   </template>
<div v-if="mng && ai===7" class="mt-3">
  <p v-if="salesSubMode!=='SpecialOrdersRefresh' && salesSubMode!=='quiz' && salesSubMode!=='bonus'">Менеджер</p>
<p v-if="mng && !boss && salesSubMode!=='SpecialOrdersRefresh'  && salesSubMode!=='quiz' && salesSubMode!=='bonus'">{{ selectedManager.ManagerCode }}</p>
<select v-if="boss && salesSubMode!=='SpecialOrdersRefresh'  && salesSubMode!=='quiz' && salesSubMode!=='bonus'" v-model="selectedMng" @change="$emit('selectManager',selectedMng)" class="form-control custom-select" id="inputGroupSelect01">
  <template v-for="(manager, index) in managers">
    <option :key = "index"> {{manager.ManagerCode}}</option>
  </template>
</select>
<template v-if="salesSubMode!=='bonus'  && salesSubMode!=='quiz' && salesSubMode!=='bonus' && salesSubMode!=='CRM'">
  <div>
    <div class="datepicker-trigger mt-3" title="Даты">
      Календарь
      <input
        class="col"
        type="text"
        id="datepicker-trigger"
        placeholder="Выберите даты"
        :value="formatDates(dateOne, dateTwo)"
      >
      <modal  removeBackdrop side position="top-left" size="sm" @close="showModal = false">
      <AirbnbStyleDatepicker
        :trigger-element-id="'datepicker-trigger'"
        :mode="'range'"
        :fullscreen-mobile="true"
        :inline="false"
        :date-one="dateOne"
        :date-two="dateTwo"
        @date-one-selected="val => { dateOne = val }"
        @date-two-selected="val => { dateTwo = val }"
        @apply="apply()"
      />
     </modal>
    </div>
  </div>
 </template>
 <mdb-btn-group class="mt-4 d-flex justify-content-around">
   <mdb-btn size="lg" class="d-flex justify-content-around" title = "Статистика заказов из B2B" :class="{'active':salesSubMode==='Visits'}" color="cyan" @click.native="changeSalesSubMode('Visits')">Статистика <i class="fa-lg fa-solid fa-chart-column"></i></mdb-btn>
</mdb-btn-group>
<mdb-btn-group class="mt-4 d-flex justify-content-around">
    <mdb-btn size="lg" title = "CRM" color="cyan darken-4" class="d-flex justify-content-around" :class="{'active':salesSubMode==='CRM'}" @click.native="changeSalesSubMode('CRM')">CRM <i class="fa-solid fa-lg fa-chart-line"></i></mdb-btn>
</mdb-btn-group>
  <div v-if="salesSubMode==='CRM'">
    <mdb-btn-group class="mt-4 d-flex justify-content-between">
      <mdb-btn size="md" @click.native="selectedclass = 'AX'" color="success">AX</mdb-btn>
      <mdb-btn size="md" @click.native="selectedclass = 'AY'" color="green">AY</mdb-btn>
      <mdb-btn size="md" @click.native="selectedclass = 'AZ'" color="default">AZ</mdb-btn>
    </mdb-btn-group>
    <mdb-btn-group class="mt-2 d-flex justify-content-between">
      <mdb-btn size="md" @click.native="selectedclass = 'BX'" color="info">BX</mdb-btn>
      <mdb-btn size="md" @click.native="selectedclass = 'BY'" color="primary">BY</mdb-btn>
      <mdb-btn size="md" @click.native="selectedclass = 'BZ'" color="light-blue darken-2">BZ</mdb-btn>
    </mdb-btn-group>
    <mdb-btn-group class="mt-2 d-flex justify-content-between">
      <mdb-btn size="md" @click.native="selectedclass = 'CX'" color="yellow">CX</mdb-btn>
      <mdb-btn size="md" @click.native="selectedclass = 'CY'" color="orange">CY</mdb-btn>
      <mdb-btn size="md" @click.native="selectedclass = 'CZ'" color="red">CZ</mdb-btn>
    </mdb-btn-group>
    <mdb-btn-group class="mt-2">
      <mdb-btn size="md" @click.native="selectedclass = ''" color="elegant">ВСЕ</mdb-btn>
    </mdb-btn-group>
  </div>
  <mdb-btn-group v-if="salesSubMode==='CRM'" class="mt-4 d-flex justify-content-between">
      <mdb-btn size="lg" title = "Отправить письма всем просроченным" class="d-flex justify-content-around" :class="{'active':salesSubMode==='CRM'}" color="cyan" @click.native="changeSalesSubMode('CRM')"><i class="fa-lg fas fa-mail-bulk"></i></mdb-btn>
  </mdb-btn-group>
  <div v-if="salesSubMode==='CRM'" class="custom-control custom-checkbox">
       <input @input="changeDebt()" type="checkbox" v-model = "partnersDebt" class="custom-control-input" id="defaultChecked2" unhecked>
       <label class="custom-control-label mt-3" for="defaultChecked2">Только просроченная</label>
  </div>
  <mdb-btn-group v-if = "boss" class="mt-4 d-flex justify-content-between">
      <mdb-btn size="lg" title = "Ход проведения акции" class="d-flex justify-content-around" :class="{'active':salesSubMode==='bonus'}" color="cyan" @click.native="changeSalesSubMode('bonus')">Акция <i class="fas fa-gift fa-lg"></i></mdb-btn>
  </mdb-btn-group>
  <mdb-btn-group v-if = "boss  || Login === '000000009' || Login === '000024911'" class="mt-4 d-flex justify-content-between">
      <mdb-btn size="lg" title = "Результаты опроса" class="d-flex justify-content-around" :class="{'active':salesSubMode==='quiz'}" color="cyan" @click.native="changeSalesSubMode('quiz')">Опрос <i class="fas fa-user-secret fa-lg"></i></mdb-btn>
  </mdb-btn-group>
  <mdb-btn-group v-if = "false && boss" class="mt-4 d-flex justify-content-between">
      <mdb-btn size="lg" title = "Экспорт папок в CSV" :class="{'active':salesSubMode==='ExportP'}" color="cyan" @click.native="changeSalesSubMode('ExportP')"><i class="fa-lg fa-solid fa-file-csv"></i></mdb-btn>
      <mdb-btn size="lg" title = "Экспорт товаров в CSV" color="cyan darken-4" :class="{'active':salesSubMode==='ExportT'}" @click.native="changeSalesSubMode('ExportT')"><i class="fa-solid fa-lg fa-file-csv"></i></mdb-btn>
  </mdb-btn-group>
  <mdb-btn-group v-if="mng && (Login === '000000009' || Login === '000000029' || Login === '000000007'|| Login === '000000039' || Login === '0000000055')" class="mt-4 d-flex justify-content-between">
      <mdb-btn size="lg" title = "Обработка и обновление списка заказных позиций" class="d-flex justify-content-around" :class="{'active':salesSubMode==='SpecialOrdersRefresh'}" color="cyan" @click.native="changeSalesSubMode('SpecialOrders'),changeSalesSubMode('SpecialOrdersRefresh')">Заказные<i class="fas fa-truck white-text fa-lg"></i></mdb-btn>
  </mdb-btn-group>

</div>
<div v-if="mng && ai===10" class="mt-3">
<template>
   <div>
    <div class="datepicker-trigger mt-3" title="Даты">
      Даты
      <input
        class="col"
        type="text"
        id="datepicker-trigger"
        placeholder="Выберите даты"
        :value="formatDates(dateOne, dateTwo)"
      >
<modal  removeBackdrop side position="top-left" size="sm" @close="showModal = false">
      <AirbnbStyleDatepicker
        :trigger-element-id="'datepicker-trigger'"
        :mode="'range'"
        :fullscreen-mobile="true"
        :inline="false"
        :date-one="dateOne"
        :date-two="dateTwo"
        @date-one-selected="val => { dateOne = val }"
        @date-two-selected="val => { dateTwo = val }"
        @apply="apply()"
      />
  </modal>
    </div>
    </div>
 </template>
</div>
<div v-if="mng && ai===11" class="mt-3">
<template>
  <list-group-item class="btn color-white black-text"  @click.native="getSupplierOrderList" :active="activeOrder === -1">
    <i class="fa fa-refresh" aria-hidden="true"></i>
  </list-group-item>
  <list-group class="light-blue-color">
    <div class="row">
      <div class="col-md-6" v-for="(order, index) in supplierOrderList" :key="order">
        <list-group-item class="btn btn-sm color-white black-text"  @click.native="cngOrder(order, index)" :active="activeOrder === index">
        {{order}}
        </list-group-item>
      </div>
      <div class="col-md-6" v-for="(invoice, indexI) in supplierInvoicesList" :key="indexI">
        <list-group-item class="btn btn-sm stylish-color white-text"  @click.native="cngInvoice(invoice, indexI)" :active="activeInvoice === indexI">
        {{invoice}}
        </list-group-item>
      </div>
    </div>
  </list-group>
</template>
</div>
</div>
</template>

<script>
import {
  Btn,
  mdbBtn,
  mdbBtnGroup,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Container,
  NumericInput,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody
} from 'mdbvue'
import format from 'date-fns/format'
import ApiService from '@/services/ApiService'
// import subDays from 'date-fns/sub_days'
// import addDays from 'date-fns/add_days'

export default {
  name: 'sidebar',
  components: {
    Btn,
    mdbBtn,
    mdbBtnGroup,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Container,
    NumericInput,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody
  },
  props: ['Login', 'authorized', 'goods', 'mng', 'boss', 'ai', 'managers', 'partnersDebt', 'folders', 'supplierInvoice', 'selectedManager', 'activeMng', 'contragents', 'deliverySchemes', 'startDate', 'endDate', 'showFavs', 'salesSubMode'],
  computed: {
    folderList0 () {
      return this.folders.filter(folder => {
        if (folder.RoditelCode === '00000000001' && folder.NomNaim.charAt(0) !== '!') return true
        else return false
      })
    },
    folderList1 () {
      return this.folders.filter(folder => {
        if (folder.RoditelCode === this.activeFolderUid0) return true
        else return false
      })
    },
    folderList2 () {
      return this.folders.filter(folder => {
        if (folder.RoditelCode === this.activeFolderUid1) return true
        else return false
      })
    }
  },
  updated () {
    // if (this.selectedManager.ManagerCode !== this.selectedMng) this.$emit('selectManager', this.selectedMng)

  },
  async mounted () {
    if (this.mng) {
      this.dateOne = this.startDate
      this.dateTwo = this.endDate
      this.getSupplierOrderList()
      console.log('SIDEBAR MOUNTED ', this.prices.length, ' retail prices found')

      console.log('this.selectedManager.ManagerCode ', this.selectedManager.ManagerCode)
      this.selectedMng = this.selectedManager.ManagerCode
    }
  },
  data () {
    return {
      openbox: true,
      selectedScheme: '09575470-60c2-11e7-ac65-001dd8b723ef',
      prices: [],
      goodsToCSV: [],
      bbIndex: 0,
      supplierOrderList: [],
      supplierInvoicesList: [],
      activeOrder: -1,
      activeInvoice: -1,
      selectedclass: '',
      selectedMng: this.selectedManager,
      activeFolder0: -1,
      activeFolder1: null,
      activeFolder2: null,
      activeFolderUid0: '',
      activeFolderUid1: null,
      activeFolderUid2: null,
      dateFormat: 'DD/M',
      dateOne: this.startDate,
      dateTwo: this.endDate
    }
  },
  methods: {
    async changeSalesSubMode (mode) {
      console.log(mode)

      await new Promise(resolve => setTimeout(resolve, 10))
      this.$emit('load')

      if (mode === 'ExportP') this.exportFoldersToCSV()
      if (mode === 'ExportT') this.exportGoodsToCSV()
      this.$emit('changeSalesSubMode', mode)
    },
    async exportGoodsToCSV () {
      const response1 = await ApiService.getPricesFile()
      this.prices = await response1.data
      this.prices.forEach((good) => {
        good.Cena = parseFloat(good.Cena.replaceAll(',', '.'))
      })
      this.prices = this.prices.filter(price => price.TipCenCode === '000000103')
      // Создаем именованный массив
      this.goodsToCSV = []

      // Заполняем массив значениями из другого массива folders
      for (let i = 0; i < this.goods.length; i++) {
        let good = this.goods[i]
        if (good.Vigr7712 === 'Да') {
          let item = {
            ID: good.NomCode,
            Артикул: good.NomCode,
            Имя: good.NomNaim,
            КраткоеОписание: good.NomNaim,
            Описание: good.NomNaim,
            Наличие: isNaN(good.skladMain - good.skladMainRezerv + good.skladBelka - good.skladBelkaRezerv) ? 0 : good.skladMain - good.skladMainRezerv + good.skladBelka - good.skladBelkaRezerv,
            БазоваяЦена: this.getRetailPrice(good.NomCode),
            Категории: this.folderName(good.RoditelCode),
            Изображения: good.hasPicture === false ? '' : 'https://b2.belca.by/images/720/' + good.NomCode + '.jpg'
          }
          this.goodsToCSV.push(item)
        }
      }
      /*
      // Преобразуем массив в CSV-строку
      let csv = 'ID,Артикул,Имя,"Краткое описание",Описание,Наличие,"Базовая цена",Категории,Изображения\n'
      for (let i = 0; i < this.goodsToCSV.length; i++) {
        let item = this.goodsToCSV[i]
        csv += `${item.ID},${item.Артикул},"${item.Имя}","${item.КраткоеОписание}","${item.Описание}",${item.Наличие},${item.БазоваяЦена},"${item.Категории}","${item.Изображения}"\n`
      }

      // Создаем и скачиваем файл CSV
      let downloadLink = document.createElement('a')
      downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      downloadLink.download = 'goods.csv'
      downloadLink.click()
      */
      const chunkSize = 1000 // Размер каждой части массива
      const chunks = Math.ceil(this.goodsToCSV.length / chunkSize) // Количество частей

      for (let i = 0; i < chunks; i++) {
        let csv = 'ID,Артикул,Имя,"Краткое описание",Описание,Наличие,"Базовая цена",Категории,Изображения\n'
        const start = i * chunkSize
        const end = start + chunkSize
        const chunk = this.goodsToCSV.slice(start, end)

        for (let j = 0; j < chunk.length; j++) {
          let item = chunk[j]
          csv += `${item.ID},${item.Артикул},"${item.Имя}","${item.КраткоеОписание}","${item.Описание}",${item.Наличие},${item.БазоваяЦена},"${item.Категории}","${item.Изображения}"\n`
        }

        let downloadLink = document.createElement('a')
        downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        downloadLink.download = `goods_${i + 1}.csv`
        this.$emit('spinneroff')
        downloadLink.click()
      }
    },
    folderName (roditelCode) {
      var foldername = ''
      var name = this.folders.filter(item => item.NomCode === roditelCode)
      // console.log('name ', name[0].RoditelCode)

      if (name.length === 1) {
        // console.log('name ', name[0].roditelCode)
        if (name[0].RoditelCode === '00000000001') {
          foldername = 'Главная > ' + name[0].NomNaim
        } else {
          var nameR = this.folders.filter(item => item.NomCode === name[0].RoditelCode)
          if (nameR.length === 1) {
            foldername = nameR[0].NomNaim + ' > ' + name[0].NomNaim
          }
        }
      }
      // console.log('foldername ', foldername)

      return foldername
    },
    getRetailPrice (NomCode) {
      // console.log('NomCode = ', NomCode)

      var pr = this.prices.filter(price => price.NomCode === NomCode)
      // console.log(pr)
      if (pr.length === 1) {
        // console.log(pr[0].Cena)
        return pr[0].Cena
      } else return 0
    },
    exportFoldersToCSV () {
      // Создаем именованный массив
      let namedArray = []

      // Заполняем массив значениями из другого массива folders
      for (let i = 0; i < this.folders.length; i++) {
        let folder = this.folders[i]
        if (this.folders[i].NomNaim !== '!Каталог продукции') {
          if (folder.RoditelCode === '00000000001') folder.RoditelCode = 15
          let item = {
            term_id: folder.NomCode.replace(/^0+/, ''),
            name: folder.NomNaim,
            slug: this.transliterate(folder.NomNaim).replace(/\s/g, ''),
            description: folder.NomNaim,
            display_type: 'subcategories',
            parent: folder.RoditelCode.toString().replace(/^0+/, ''),
            thumbnail: ''
          }

          console.log(item.parent)

          namedArray.push(item)
        }
      }

      // Преобразуем массив в CSV-строку
      let csv = 'term_id;name;slug;description;display_type;parent;thumbnail\n'
      for (let i = 0; i < namedArray.length; i++) {
        let item = namedArray[i]
        csv += `${item.term_id};"${item.name}";${item.slug};"${item.description}";${item.display_type};${item.parent};${item.thumbnail}\n`
      }

      // Создаем и скачиваем файл CSV
      let downloadLink = document.createElement('a')
      downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      downloadLink.download = 'folders.csv'
      downloadLink.click()
    },
    transliterate (str) {
      const cyrillicToLatinMap = {
        а: 'a',
        б: 'b',
        в: 'v',
        г: 'g',
        д: 'd',
        е: 'e',
        ё: 'yo',
        ж: 'zh',
        з: 'z',
        и: 'i',
        й: 'y',
        к: 'k',
        л: 'l',
        м: 'm',
        н: 'n',
        о: 'o',
        п: 'p',
        р: 'r',
        с: 's',
        т: 't',
        у: 'u',
        ф: 'f',
        х: 'h',
        ц: 'c',
        ч: 'ch',
        ш: 'sh',
        щ: 'sch',
        ъ: '',
        ы: 'y',
        ь: '',
        э: 'e',
        ю: 'yu',
        я: 'ya',
        А: 'A',
        Б: 'B',
        В: 'V',
        Г: 'G',
        Д: 'D',
        Е: 'E',
        Ё: 'YO',
        Ж: 'ZH',
        З: 'Z',
        И: 'I',
        Й: 'Y',
        К: 'K',
        Л: 'L',
        М: 'M',
        Н: 'N',
        О: 'O',
        П: 'P',
        Р: 'R',
        С: 'S',
        Т: 'T',
        У: 'U',
        Ф: 'F',
        Х: 'H',
        Ц: 'C',
        Ч: 'CH',
        Ш: 'SH',
        Щ: 'SCH',
        Ъ: '',
        Ы: 'Y',
        Ь: '',
        Э: 'E',
        Ю: 'YU',
        Я: 'YA'
      }

      return str.replace(/[а-яА-ЯёЁ]/g, (match) => cyrillicToLatinMap[match] || '')
    },
    selectScheme (event) {
      console.log(event.target.value)
      this.$emit('selectScheme', event.target.value)
    },
    changeOrdered () {
      this.$emit('changeordered')
    },
    changeAll () {
      this.$emit('changeAll')
    },
    changeInStock () {
      this.$emit('changeInStock')
    },
    changeNotInStock () {
      this.$emit('changeNotInStock')
    },
    changeDebt () {
      this.$emit('changedebt')
    },
    apply () {
      console.log(this.dateOne + ' ' + this.dateTwo)
      this.$emit('DateSelected', {dateone: this.dateOne, datetwo: this.dateTwo})
      // this.$bus.$emit('StatementDateSelected', {dateone: this.dateOne, datetwo: this.dateTwo})
    },
    start () {
    },
    formatDates (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    cngOrder (order, index) {
      console.log(order)
      this.activeOrder = index
      this.activeInvoice = -1
      this.$emit('SupplierTransit', order)
    },
    cngInvoice (invoice, index) {
      console.log(invoice)
      this.activeInvoice = index
      this.activeOrder = -1
      this.$emit('SupplierInvoice', invoice)
    },
    cngfolder0 (folder0, index0) {
      this.activeFolder0 = index0
      this.activeFolder1 = -1
      this.activeFolder2 = -1
      if (index0 === -1) folder0.NomCode = '00000000001'
      // this.activeFolderUid0 = folder0.Ref_Key
      // this.activeFolderUid1 = '00000000-0000-0000-0000-000000000000'
      // this.activeFolderUid2 = '00000000-0000-0000-0000-000000000000'
      if (this.activeFolderUid0 === folder0.NomCode) {
        this.activeFolderUid0 = '00000000001'
        this.activeFolderUid1 = '00000000001'
        this.activeFolderUid2 = '00000000001'
      } else {
        this.activeFolderUid0 = folder0.NomCode
        this.activeFolderUid1 = '00000000001'
        this.activeFolderUid2 = '00000000001'
      }
      this.$emit('folder0', folder0.NomCode)
      this.$emit('folder1', '00000000001')
      this.$emit('folder2', '00000000001')
      // console.log('folder0', folder0.Ref_Key)
    },
    cngfolder1 (folder1, index1) {
      this.activeFolder1 = index1
      this.activeFolder2 = -1
      if (this.activeFolderUid1 === folder1.NomCode) {
        this.activeFolderUid1 = '00000000001'
      } else {
        this.activeFolderUid1 = folder1.NomCode
      }
      this.$emit('folder1', folder1.NomCode)
      this.$emit('folder2', '00000000001')
      // console.log('folder1', folder1.Ref_Key)
    },
    async getSupplierOrderList () {
      console.log('getSupplierOrderList')
      let answer = await ApiService.getSupplierOrderList()
      this.supplierOrderList = answer.data
      this.activeOrder = -1
      this.$emit('SupplierTransit', -1)
      console.log('getSupplierInvoicesList')
      answer = await ApiService.getSupplierInvoicesList()
      this.supplierInvoicesList = answer.data // .slice(0, 20)
      // console.log(this.supplierInvoicesList)
    }
  },
  watch: {
    selectedclass () {
      this.$bus.$emit('selectedclass', this.selectedclass)
    },
    startDate () {
      this.dateOne = this.startDate
    },
    endDate () {
      this.dateTwo = this.endDate
    },
    showFavs () {
      if (this.showFavs === true) {
        this.activeFolder0 = -1
        this.activeFolderUid0 = '00000000001'
        this.$emit('folder0', '00000000001')
        this.$emit('folder2', '00000000001')
        this.$emit('folder1', '00000000001')
        /*
        this.cngfolder0('00000000001', -1)
        this.cngfolder1('00000000001', -1)
        this.cngfolder2('00000000001', -1)
        this.activeFolderUid0 = '00000000001'
        this.activeFolderUid1 = '00000000001'
        this.activeFolderUid2 = '00000000001'
        this.$emit('folder0', '00000000001')
        this.$emit('folder1', '00000000001')
        this.$emit('folder2', '00000000001')
        */
      }
    }
  }
}

</script>
<style scoped>

body{
  line-height: 1.0;
}
.navbar.navbar-light .navbar-toggler-icon {
      background-color: #00acc1 !important;
}
 .btn:not(:disabled):not(.disabled) {
    cursor: default;
    user-select: none;
}
.btn.btn-sm2 {
    padding: 0.1rem 0.4rem;
    font-size: 0.6rem;
    margin-left: 1rem;
    color: #212529;
    user-select: none;
}
.list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    user-select: none;
    border: 0px;
    cursor: pointer;
    border-left: 5px solid rgba(0, 0, 0, 0.125);
  }
.list-group-item.active {
    z-index: 2;
    user-select: none;
    font-weight: bold;
    color:#263238;
    background-color: #e9ecef;
    border-color: #263238;
    border-left: 5px solid #263238;
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.18);
}
.list-group .list-group-item:last-child {
    margin-bottom: 3px;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue